import { createVNode as a, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowTopFilledStandard.js";
import i from "../components/PfIcon.js";
const r = (o, t) => {
  const e = {
    ...o,
    ...t.attrs
  };
  return a(i, d(e, {
    icon: l
  }), null);
};
r.displayName = "ArrowTopFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
